import { Avatar, Box, Button, Paper, Stack, Typography } from "@mui/material";

export function EmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  actionIcon,
  compact = false,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        minHeight: compact ? 132 : 220,
        p: compact ? { xs: 2, md: 2.5 } : { xs: 2.5, md: 3.5 },
        border: "1px dashed",
        borderColor: "rgba(148, 163, 184, 0.55)",
        borderRadius: 2,
        bgcolor: "#fbfdff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack
        spacing={1.5}
        alignItems="center"
        textAlign="center"
        sx={{ maxWidth: 520, mx: "auto" }}
      >
        {icon ? (
          <Avatar
            sx={{
              width: compact ? 42 : 52,
              height: compact ? 42 : 52,
              bgcolor: "#eff6ff",
              color: "#2563eb",
            }}
          >
            {icon}
          </Avatar>
        ) : null}
        <Box>
          <Typography sx={{ fontWeight: 800, color: "text.primary" }}>
            {title}
          </Typography>
          {description ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 0.5,
                lineHeight: 1.65,
                overflowWrap: "anywhere",
                wordBreak: "keep-all",
              }}
            >
              {description}
            </Typography>
          ) : null}
        </Box>
        {actionLabel && onAction ? (
          <Button
            variant="contained"
            startIcon={actionIcon}
            onClick={onAction}
            sx={{ width: { xs: "100%", sm: "auto" }, fontWeight: 700 }}
          >
            {actionLabel}
          </Button>
        ) : null}
      </Stack>
    </Paper>
  );
}
